import {update} from '../../../utils/vuex'


export default {
    update
    // update (state, account) {
    //     if (account && account.uid > 0) {
    //         state.info = account
    //     } else {
    //         state.info = null
    //     }
    // }
}
